// What stay a search is for, from what the date picker stored (components/SearchDatesModal).
//
//   exact dates          the picked dates are the stay
//   dates ± N days       the picked dates are still the stay; the hub looks N days either side
//   Flexible (a month)   the stored dates are only a WINDOW (the whole month); the stay is
//                        `searchStayNights` nights somewhere inside it
//
// Prices went wrong when these were mixed up: a month window was priced as a 30-night stay, and a
// card without a calendar took any flexible search for "no dates" and multiplied a week's total by
// the villa's minimum stay (6 Oct 2026: 12,896 for the week shown as 90,272 "for 7 nights").

const read = (storage, key) => {
  try { return storage.getItem(key); } catch (e) { return null; }
};

const nightsBetween = (from, to) => {
  const start = new Date(from).getTime();
  const end = new Date(to).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end)) return 0;
  return Math.max(0, Math.round((end - start) / 86400000));
};

export function searchStay(storage = localStorage) {
  const dateFrom = read(storage, "dateFrom");
  const dateTo = read(storage, "dateTo");
  const mode = read(storage, "searchFlexMode") || "dates";
  const flexDays = parseInt(read(storage, "searchFlexDays"), 10) || 0;
  const stayNights = parseInt(read(storage, "searchStayNights"), 10) || 0;
  const hasDates = Boolean(dateFrom && dateTo);
  const windowNights = hasDates ? nightsBetween(dateFrom, dateTo) : 0;
  return {
    hasDates,
    // "± days" and the Flexible tab
    flexible: mode === "flexible" || flexDays > 0,
    // the stored dates are a window to look in, not a stay
    datesAreAWindow: mode === "flexible",
    // how many nights the price is for
    nights: stayNights > 0 ? stayNights : windowNights,
  };
}

export default searchStay;
